<div class="project-info-container" (click)="projectInfoVisible = !projectInfoVisible">
  <div class="project-icon">
    <ng-casto-button [faIcon]="faList" class="secondary borderless"></ng-casto-button>
  </div>
  <div class="info">
    <span [innerHTML]="'project-info.title'|translate"></span>
  </div>
  <div class="open-icon">
    <fa-icon [icon]="faChevronRight"></fa-icon>
  </div>
</div>


<p-sidebar styleClass="project-info-sidebar" [(visible)]="projectInfoVisible" position="right" baseZIndex="3000"
  appendTo="body">
  <ng-template pTemplate="header">
    <span class="casto-title decorator" [innerHTML]="'project-info.flyer-title'|translate"></span>
  </ng-template>
  <div class="content">
    <!--
      Désactivé volontairement pour le moment.
      Ce bloc affichait dans "Mon projet étape par étape" les informations de la
      dernière commande menuiserie, notamment le numéro de commande Castorama
      et le numéro d'opportunité.
    -->
    <!-- @if (hasCarpentryOrderInformation) {
    <div class="content-row">
      <div class="price">
        <span [innerHTML]="'project-info.order-info.title'|translate"></span>
      </div>
      <div class="details">
        @if (currentCarpentryOrder?.orderNumber != null) {
        <div class="detail">
          <span [innerHTML]="'project-info.order-info.order-number'|translate"></span>
          <span class="blue" [innerHTML]="currentCarpentryOrder?.orderNumber"></span>
        </div>
        }
        @if (currentCarpentryOrder?.opportunityNumber != null && currentCarpentryOrder?.opportunityNumber !== 0) {
        <div class="detail">
          <span [innerHTML]="'project-info.order-info.opportunity-number'|translate"></span>
          <span class="blue" [innerHTML]="currentCarpentryOrder?.opportunityNumber"></span>
        </div>
        }
      </div>
    </div>
    } -->

    @if (currentPricing?.totalConception) {
    <div class="content-row">
      <div class="price">
        <span [innerHTML]="'project-info.conception'|translate"></span>
        @if (loading) {
        <ng-casto-loader></ng-casto-loader>
        } @else {
        <span class="blue"
          [innerHTML]="currentPricing?.totalConception.actualAmount|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
        }
      </div>
      @if (currentPricing?.extraPricing && totalExtraPricing?.actualAmount > 0) {
      <div class="details">
        <div class="detail">

          <span [innerHTML]="'project-info.extra-pricing.'+customerService.context|translate"></span>
          @if (loading) {
          <ng-casto-loader></ng-casto-loader>
          } @else {
          <span [innerHTML]="totalExtraPricing?.actualAmount|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
          }

        </div>
      </div>
      }
    </div>
    }

    @if (currentPricing?.delivery) {
    <div class="content-row">
      <div class="price">
        <span [innerHTML]="'project-info.delivery'|translate"></span>
        @if (loading) {
        <ng-casto-loader></ng-casto-loader>
        } @else {
        <span class="blue"
          [innerHTML]="currentPricing?.delivery.actualAmount|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
        }
      </div>
    </div>
    }
    @if (currentPricing?.totalInstallation && installationState?.withInstallation && featureSettingsService.poseEnabled) {
    <div class="content-row">
      <div class="price">
        <span [innerHTML]="'project-info.installation'|translate"></span>
        @if (loading) {
        <ng-casto-loader></ng-casto-loader>
        } @else {
        <span class="blue"
          [innerHTML]="currentPricing?.totalInstallation.actualAmount|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
        }
      </div>
    </div>
    }
    @if (currentPricing?.totalComplementaryProduct && currentPricing?.totalComplementaryProduct.actualAmount > 0) {
    <div class="content-row">
      <div class="price">
        <span [innerHTML]="'project-info.complementary-product'|translate"></span>
        @if (loading) {
        <ng-casto-loader></ng-casto-loader>
        } @else {
        <span class="blue"
          [innerHTML]="currentPricing?.totalComplementaryProduct.actualAmount|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
        }
      </div>
    </div>
    }
    @if (currentPricing?.totalWithoutFunding) {
    <div class="content-row">
      <div class="price">
        <span [innerHTML]="'project-info.total-without-funding.with-discount'|translate"></span>
        @if (discountNumberValue > 0) {
        <span class="casto-tag" [innerHTML]="'project-info.discount'|translate:{
            x:discountNumberValue
            }"></span>

        <span class="casto-discount"
          [innerHTML]="currentPricing?.totalWithoutFunding.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
        </span>
        }
        @if (loading) {
        <ng-casto-loader></ng-casto-loader>
        } @else {
        <span class="blue"
          [innerHTML]="currentPricing?.totalWithoutFunding.actualAmount|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
        }
      </div>
    </div>
    }

    @if (currentFundingValue && currentPricing?.totalWithFunding && featureSettingsService.financementEnabled) {
    <div class="content-row">
      <div class="price">
        <span [innerHTML]="'project-info.total-with-funding'|translate"></span>
        @if (loading) {
        <ng-casto-loader></ng-casto-loader>
        } @else {
        <span class="blue"
          [innerHTML]="currentPricing?.totalWithFunding|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
        }
      </div>

      <div class="details">
        <div class="detail">
          <span [innerHTML]="'project-info.funding.mensuality'|translate"></span>
          @if (!loading) {
          <span [innerHTML]="currentFundingValue.mensuality|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>

          }
        </div>
        <div class="detail">
          <span [innerHTML]="'project-info.funding.duration'|translate"></span>
          @if (!loading) {
          <span
            [innerHTML]="'project-info.funding.duration-value'|translate : { value: currentFundingValue.duration}"></span>
          }

        </div>
        <div class="detail">
          <span [innerHTML]="'project-info.funding.interest'|translate"></span>
          @if (!loading) {
          <span [innerHTML]="currentFundingValue.interest|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>

          }
        </div>
        <div class="detail">
          <span [innerHTML]="'project-info.funding.down-payment'|translate"></span>
          @if (!loading) {
          <span [innerHTML]="currentFunding.downPayment|currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>

          }
        </div>
      </div>
    </div>
    }

    @if(!isInstallationDisabled && featureSettingsService.poseEnabled) {
    <div class="content-row">
      <div class="actions">
        <div class="action">
          <span class="action-label" [innerHTML]="'project-info.with-installation'|translate">
          </span>
          <p-inputSwitch [(ngModel)]="withInstallationSwitchValue" (onChange)="setWithInstallation($event.checked)" />
        </div>

      </div>
    </div>
    }
  </div>
</p-sidebar>
